
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { UploaderConsumer } from '../../Uploader';
import RequestProvider from '../../RequestProvider/components/RequestProvider';
import { AddonsConsumer } from '../../Addons';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import ManageVoiceOverArtistsComponent from '../components/ManageVoiceOverArtists';
import { getFilteredVoiceOverArtistsApi } from '../../../common/api';











function ManageVoiceOverArtists(props) {
  return (
    <AddonsConsumer>
      {({ actions: { getBillingEntityCode } }) =>
      <UploaderConsumer>
          {({ fetchAssets, assetsMap }) =>
        <RequestProvider
          requests={{
            getFilteredVoiceOverArtists: getFilteredVoiceOverArtistsApi()
          }}>

              {({ getFilteredVoiceOverArtists }) =>
          <AuthorisationConsumer>
                  {({ isShootstaUser }) =>
            <ManageVoiceOverArtistsComponent
              {...props}
              getBillingEntityCode={getBillingEntityCode}
              assetsMap={assetsMap}
              fetchAssets={fetchAssets}
              getFilteredVoiceOverArtists={getFilteredVoiceOverArtists}
              isShootstaUser={isShootstaUser} />}


                </AuthorisationConsumer>}

            </RequestProvider>}

        </UploaderConsumer>}

    </AddonsConsumer>);

}

export default ManageVoiceOverArtists;